exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.label {\n  font-size: 12px;\n}\n\n.nicePadding {\n  padding-top: 15px;\n  padding-bottom: 50px;\n}\n\n\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/messaging/message-form/message-form.component.css
// module id = ../../../../../src/app/components/messaging/message-form/message-form.component.css
// module chunks = main